import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const PieChart16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 0.25C7.58579 0.25 7.25 0.585786 7.25 1V8C7.25 8.5168 7.78505 8.88509 8.26779 8.70057L14.8082 6.20056C15.1798 6.0585 15.383 5.6037 15.2409 5.23207C14.1271 2.32 11.3062 0.25 8 0.25ZM8.75 6.9104V1.79454C10.827 2.04296 12.5921 3.31012 13.5294 5.0835L8.75 6.9104Z'
      fill='currentColor'
    />
    <path
      d='M2.75 8C2.75 5.71528 4.20984 3.76961 6.24993 3.04854L5.75007 1.63428C3.12939 2.56055 1.25 5.05983 1.25 8C1.25 11.7279 4.27208 14.75 8 14.75C11.7279 14.75 14.75 11.7279 14.75 8H13.25C13.25 10.8995 10.8995 13.25 8 13.25C5.10051 13.25 2.75 10.8995 2.75 8Z'
      fill='currentColor'
    />
  </Svg>
);

PieChart16.displayName = 'PieChart16';
export default PieChart16;
